export const pluginReviews = [
	{
		title: "This Plugin Is Excellent for making Posts display by category on a page",
		comment:
			"This is the best way I know of to make Posts display by category on different pages. Frequently posts have different categories and people want to display the posts of a particular category on one page. This is how to do it. This really should be built into WordPress.",
		name: "Ianerickson",
		profileLink: "https://wordpress.org/support/users/ianerickson/",
		profileImage: "https://secure.gravatar.com/avatar/6d8ed1beb4bba5167a922105d5d43903da5add1cf44e4434c4f6402ea6eb9c18?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/this-plugin-is-excellent-for-making-posts-display-by-category-on-a-page/",
		stars: 5,
	},
	{
		title: "The best support – EVER",
		comment: "WordPress was reporting an occasional fatal error in the Post Grid plugin.I reported on the support forum and got very quick replies resulting in a custom build to replace the plugin, fixing the issue.Really very impressed, I couldn’t ask for more.Thank you PickPlugins",
		name: "Jomega",
		profileLink: "https://wordpress.org/support/users/jomega/",
		profileImage: "https://secure.gravatar.com/avatar/3f01420af9932315e202f971a324a38b345869a0ccb625ffa6fc75520c3a6559?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/the-best-support-ever-33/",
		stars: 5,
	},
	{
		title: "Really useful plugin",
		comment: "Easy to configure and just works really well.Kudos & thanks to the Developers.I used it with the Divi theme without a problem.",
		name: "Positivit",
		profileLink: "https://wordpress.org/support/users/positivit/",
		profileImage: "https://secure.gravatar.com/avatar/e696d623a0f9574d89a7bf2b49c4c9ff7a51ad3c8823d294762baac2d312ad13?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/really-useful-plugin-108/",
		stars: 5,
	},
	{
		title: "nice plugin",
		comment: "Easy to configure and just works really well.Kudos & thanks to the Developers.I used it with the Divi theme without a problem.",
		name: "Reichsolutions",
		profileLink: "https://wordpress.org/support/users/reichsolutions/",
		profileImage: "https://secure.gravatar.com/avatar/5497b38211f39e99b662a7561f67e68a70a2adb2f566db88dbe3b817c6f7ad13?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/nice-plugin-3821/",
		stars: 5,
	},
	{
		title: "Fantastic plugin",
		comment: "Seriously impressed with how flexible this is",
		name: "Perryrylance",
		profileLink: "https://wordpress.org/support/users/perryrylance/",
		profileImage: "https://secure.gravatar.com/avatar/69e635ca5fd9e764e767cce444200d3b982a905cae72edd18295968720affd4c?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/fantastic-plugin-1542/",
		stars: 5,
	},

	{
		title: "Great plugin! gets the job done",
		comment: "Great plugin! gets the job done",
		name: "Spuri123",
		profileLink: "https://wordpress.org/support/users/spuri123/",
		profileImage: "https://secure.gravatar.com/avatar/6877dcf974aa48436675923570cfc4384083788062e39733df81031f539cf1ad?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/great-plugin-gets-the-job-done-7/",
		stars: 5,
	},



	{
		title: "Love this plugin",
		comment: "This plugin does exactly what it says it does—it helps you to create an attractive grid of posts that can be filtered by categories, taxonomies, post types, and more. I had a problem because I recently switched recipe plugins on my site and I either had to pay an annual fee to convert the old ones to the new plugin or find a way to put the recipes from the two different plugins on a single page. Post Grid helped me accomplish that. The process was easy and fast. In fact, after I got going and saw how easy it was to create the grids, I made different grids for all the subcategories.",
		name: "Islandwriter",
		profileLink: "https://wordpress.org/support/users/islandwriter/",
		profileImage: "https://secure.gravatar.com/avatar/0390dc0739e75bff157acb1dc87ae000a85f23158c0ae916a51605d7f9b91a1e?s=100&d=retro&r=g",
		link: "https://wordpress.org/support/topic/love-this-plugin-980/",
		stars: 5,
	},
];
